import { Flex, Group, Stack, useMantineTheme } from '@mantine/core';
import { IconCircle } from '@tabler/icons-react';

import { Text } from '~/domains/design-system/Text';
import { IconWeather } from '~/domains/design-system/icons/IconWeather';

import type { PlayerInfoAfterGameStart } from '../../../types/player';

export function PlayerCardAfterGameStart({
  isLive,
  playerName,
  afterPlayerNameLabel,
  play,
  meta,
  points,
  gameTime,
  dropWorstNth,
  weatherIcon,
}: Omit<PlayerInfoAfterGameStart, 'playerId' | 'isUpcoming'>) {
  const theme = useMantineTheme();

  return (
    <>
      <Flex gap={theme.other.spacing._4} align="center">
        <Text variant="headline-medium" truncate sx={{ flexShrink: 0 }}>
          {playerName}
        </Text>
        {afterPlayerNameLabel && (
          <Text variant="body-small" color="gray2.4">
            • {afterPlayerNameLabel}
          </Text>
        )}
      </Flex>
      <Flex gap={theme.other.spacing._4} sx={{ flexGrow: 1 }}>
        {isLive && (
          <Flex pt={theme.other.spacing._2}>
            <IconCircle size={10} color={theme.colors.green[6]} fill={theme.colors.green[6]} />
          </Flex>
        )}
        <Stack spacing={0}>
          <Text variant="subhead-x-small">{play}</Text>
          <Text variant="subhead-x-small" color="gray.6">
            {gameTime}
          </Text>
          {weatherIcon && (
            <IconWeather weather={weatherIcon} size={14} color={theme.colors.gray2[3]} />
          )}
        </Stack>
      </Flex>
      <Stack spacing={0}>
        {points ? (
          <Group spacing={theme.other.spacing._4}>
            <Text variant="headline-small" color={dropWorstNth ? 'gray2.2' : undefined}>
              {points.value}
            </Text>
            <Text variant="subhead-x-small" color={dropWorstNth ? 'gray2.2' : undefined}>
              {points.label}
            </Text>
          </Group>
        ) : null}
        <Text variant="body-small" color="gray.6">
          {meta?.map(({ value, label }) => `${value}${label ? ` ${label}` : ''}`).join(', ')}
        </Text>
      </Stack>
    </>
  );
}
